const initReturnRequest = function () {
    const modal = document.querySelector('[data-return-modal]');
    if (!modal) return;

    const triggers = document.querySelectorAll('[data-return-trigger]');
    if (!triggers.length) return;

    const form = modal.querySelector('[data-return-form]');
    const message = modal.querySelector('[data-return-message]');
    const submit = modal.querySelector('[data-return-submit]');

    const showMessage = (text, isError) => {
        message.textContent = text;
        message.hidden = false;
        message.classList.toggle('is-error', !!isError);
        message.classList.toggle('is-success', !isError);
    };

    const openModal = () => {
        // On mobile the hamburger menu (mmenu) wraps the page in a transformed
        // `.mm-slideout`, which becomes the containing block for our
        // `position: fixed` modal — stretching the overlay to full document
        // height and pushing the vertically-centred dialog thousands of pixels
        // off-screen. Reparent the modal to <body> (outside the slideout) so
        // `position: fixed` resolves against the viewport again. Done on open
        // (not init) because mmenu wraps every body child during its own init.
        if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
        }
        modal.hidden = false;
        document.body.classList.add('return-modal-open');
    };

    const closeModal = () => {
        modal.hidden = true;
        document.body.classList.remove('return-modal-open');
    };

    triggers.forEach((trigger) => trigger.addEventListener('click', openModal));

    modal.querySelectorAll('[data-return-close]').forEach((el) =>
        el.addEventListener('click', closeModal)
    );

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        message.hidden = true;
        submit.disabled = true;

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Accept: 'application/json',
                },
                body: new FormData(form),
            });

            const data = await response.json().catch(() => ({}));

            if (response.ok) {
                showMessage(data.message || 'Uw retouraanvraag is verstuurd.', false);
                form.reset();
            } else {
                showMessage(
                    data.message || 'Er ging iets mis. Controleer uw bestelnummer en probeer het opnieuw.',
                    true
                );
            }
        } catch (error) {
            showMessage('Er ging iets mis. Probeer het later opnieuw.', true);
        } finally {
            submit.disabled = false;

            // reCAPTCHA tokens are single-use; reset so a retry gets a fresh one.
            if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
                window.grecaptcha.reset();
            }
        }
    });
};

export default initReturnRequest;
